import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-student-geography-card',
  templateUrl: './student-geography-card.component.html',
  styleUrls: ['./student-geography-card.component.scss']
})
export class StudentGeographyCardComponent implements OnChanges, OnDestroy {

  @Input() inputProfileData: any;
  @Input() regionStatesList: any;
  @Output() profileUpdate: EventEmitter<any> = new EventEmitter<any>();
  geoForm: FormGroup;

  regionStateClassIds = [];
  formsTouched = false;
  constructor(private formBuilder: FormBuilder) {
    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inputProfileData'] !== undefined && changes['inputProfileData'].currentValue !== undefined && changes['inputProfileData'].currentValue.regionStateClassIds && changes['inputProfileData'].currentValue.regionStateClassIds.length > 0) {
      this.regionStateClassIds = this.inputProfileData.regionStateClassIds;
      this.hydrateForm(changes['inputProfileData'].currentValue);
    }
    if (this.geoForm && this.geoForm.dirty && this.geoForm.valid) {
      this.profileUpdate.emit(this.geoForm.value);
    }
  }

  buildForm() {
    this.geoForm = this.formBuilder.group({
      regionStateClassIds: [],
      citySizeClassIds: []
    });
  }

  hydrateForm(newData) {
    const values = {
      regionStateClassIds: newData.regionStateClassIds,
      citySizeClassIds: newData.citySizeClassIds
    };
    this.geoForm.patchValue(values);
  }

  changeState(state) {
    this.formsTouched = true;
    const index = this.regionStateClassIds.indexOf(state.id + '');
    if (index > -1) {
      this.regionStateClassIds.splice(index, 1);
    } else {
      this.regionStateClassIds.push(state.id + '');
    }
  }

  getGeographyData() {
    return {stateList: this.regionStateClassIds};
  }

  isChecked(id) {
    return this.regionStateClassIds.indexOf(id + '') > -1;
  }

  ngOnDestroy() {
    this.formsTouched = false;
  }
}
